import React, { useState } from 'react';
import { Page, Document } from 'react-pdf';
import Modal from 'react-modal';
import { pdfjs } from 'react-pdf';
import { Button } from '@mui/material';
pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.js';

Modal.setAppElement('#root'); // index.html の <div id="root"></div> のやつ

export default function PdfModalViewer({ filePath, isOpen, onClose, startPage = 1, endPage }) {
  const [numPages, setNumPages] = useState(null);

  const handleLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const actualEndPage = endPage && endPage <= numPages ? endPage : numPages;

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="PDF Viewer"
      style={{
        overlay: {
          zIndex: 1300, // ← MUI のダイアログや AppBar と被らんように高め！
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        },
        content: {
          width: '90%',
          height: '90%',
          margin: 'auto',
          overflow: 'auto',
          zIndex: 1400,
        },
      }}
    >
      <Button onClick={onClose} variant='outlined'>閉じる</Button>

      <style>
        {`
        .pdf-content {width: 120%;}
        @media only screen and (max-width: 610px) {
        .pdf-content {width: 130%;}
        }
        @media only screen and (max-width: 560px) {
        .pdf-content {width: 150%;}
        }
        @media only screen and (max-width: 500px) {
        .pdf-content {width: 180%;}
        }
        @media only screen and (max-width: 440px) {
        .pdf-content {width: 210%;}
        }
        @media only screen and (max-width: 390px) {
        .pdf-content {width: 250%;}
        }
        @media only screen and (max-width: 350px) {
        .pdf-content {width: 290%;}
        }
        `}
       </style>

      <div className='pdf-content'>
        <Document
          file={filePath}
          onLoadSuccess={handleLoadSuccess}
          loading="読み込み中..."
        >
        {numPages && Array.from({ length: numPages }, (_, index) => {
            const pageNum = index + 1;
            if (pageNum < startPage || pageNum > actualEndPage) return null;
            return (
                <div key={`wrapper_${pageNum}`} style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
                <Page
                    pageNumber={pageNum}
                    width={800}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                />
                </div>
            );
        })}
        </Document>
      </div>
    </Modal>
  );
}